import { AIAgentType } from "./types";

export const aiGradientBackgroundClassName =
  "bg-[linear-gradient(237deg,_#F33A9E_1.05%,_#2196F3_86.49%)]";

export const aiGradientHoverBackgroundClassName =
  "hover:bg-[linear-gradient(0deg,_rgba(0,0,0,0.06)_0%),_linear-gradient(237deg,_#F33A9E_1.05%,_#2196F3_86.49%)]";

const taskBoardSuggestions = [
  "Create Board Summary",
  "What are the open tasks in this Board?",
  "What actions should I perform Next?",
];

export const AIPromptSuggestions: Record<AIAgentType, string[]> = {
  [AIAgentType.help]: [
    "Get Help with Onboarding",
    "Explore About Boards",
    "Get to know about Customers in Jugl",
    "Explore About Integrations in Jugl",
  ],
  [AIAgentType.myTasks]: taskBoardSuggestions,
  [AIAgentType.board]: taskBoardSuggestions,
};
